module.exports = __webpack_public_path__ + "media/images/application/social_sharing/facebook-19ad77d66da88de5b894d7bcddcc8e1b.png";